import { render, staticRenderFns } from "./dialogPdftoImageThumb.vue?vue&type=template&id=2e36b994&scoped=true&"
import script from "./dialogPdftoImageThumb.vue?vue&type=script&lang=js&"
export * from "./dialogPdftoImageThumb.vue?vue&type=script&lang=js&"
import style0 from "./dialogPdftoImageThumb.vue?vue&type=style&index=0&id=2e36b994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e36b994",
  null
  
)

export default component.exports
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinner,QIcon});
